export const TYPE_SCORE = {
  CREDIT: 'dashboard.yourPortfolio.creditScore',
  PERFORMANCE: 'dashboard.yourPortfolio.performanceScore',
}

export const PERFORMANCE_SCORE_COLOR_ID = {
  1: '#87D4A4',
  2: '#C3D785',
  3: '#FFDE86',
  4: '#EB6671',
  5: '#BCBCBC',
}
